export const selectGuestId = ({user}) => user?.guestId;
export const selectUserId = ({user}) => user?.userId;
export const selectIsHost = ({user}) => user?.isHost;
export const selectUserName = ({user}) => user?.name;
export const selectUserEmail = ({user}) => user?.email;

export const selectUserFirstName = (state) => {
  const name = state.user?.name || '';
  return name.trim().split(/\s+/)[0] || '';
};

export const selectUserLastName = (state) => {
  const name = state.user?.name || '';
  const parts = name.trim().split(/\s+/);
  return parts.length > 1 ? parts[parts.length - 1] : '';
};
